import { FC } from "react";

import { UploadDealersForm } from "~/features/uploadData/uploadDealers";
import { UploadEmployeeDataForm } from "~/features/uploadData/uploadEmployeeData";
import { UploadIndicatorsForm } from "~/features/uploadData/uploadIndicators";
import { UploadRegMenForm } from "~/features/uploadData/uploadRegMen";
import { UploadSrrForm } from "~/features/uploadData/uploadSrr";
import { PermissionKey } from "~/types/Permissions";

import { UploadDataFormProps, UploadDataType } from "./types";

export interface UploadDataOptionConfig {
  value: UploadDataType;
  permissions?: PermissionKey[];
  component: FC<UploadDataFormProps>;
}

export const UPLOAD_DATA_OPTIONS: UploadDataOptionConfig[] = [
  {
    value: "upload_indicators",
    permissions: ["indicator.values.upload"],
    component: UploadIndicatorsForm,
  },
  {
    value: "upload_dealers",
    permissions: ["users.acceptUploadUserToDealer"],
    component: UploadDealersForm,
  },
  {
    value: "upload_regMen",
    permissions: ["users.uploadUserToDealer"],
    component: UploadRegMenForm,
  },
  {
    value: "upload_SRR",
    permissions: ["srr.target.set"],
    component: UploadSrrForm,
  },
  {
    value: "upload_employeeData",
    component: UploadEmployeeDataForm,
  },
];
